import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { HttpClient } from '@angular/common/http';

import { ImportLogsService } from '@services/import-logs/import-logs.service';
import { ImportService } from '@services/imports/import.service';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { PageAction } from '../../../../components/page-actions/page-actions.component';
import { EnvironmentService } from '@services/environment/environment.service';

@Component({
    selector: 'app-pipe-import-logs-detail',
    templateUrl: './pipe-import-logs-detail.component.html',
    styleUrls: ['./pipe-import-logs-detail.component.scss'],
    providers: [ImportLogsService, ImportService, PipeImportService],
    standalone: false
})
export class PipeImportLogsDetailComponent implements OnInit {

  public importLog: Models.ImportLog;

  public jsonLog: any;

  public pageActions: PageAction[];

  public compositions: any[];

  public isLoading = false;

  public title;
  public subtitle;

  public importId: string = null;

  constructor(
    public importLogsService: ImportLogsService,
    public pipeImportService: PipeImportService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.title = 'Log JSON: ';
    this.importLogsService.get(this.route.snapshot.params['logId']).then(response => {
      this.importLog = response;
      this.importId = response.importId;
      this.pipeImportService.get(this.importId).then(responseImport => {
        this.title = 'Log of Importer: ' + responseImport.title;
      });

      return this.http.get(this.environmentService.getLogFileRequestUrl() + this.importLog.logFileURL).subscribe(responseJSON => {
        this.jsonLog = responseJSON;
      });
    });
    this.createPageActions();
    this.isLoading = false;
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Importer',
        callback: () => {
          this.router.navigate(['pipe-imports/', this.importId]);
        }
      })
    ];
  }
}
